import React from 'react';

interface IconEditProps {
    iconClasses?: string;
}

const IconEdit: React.FC<IconEditProps> = ({ iconClasses }) => {
    return (
        <svg
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-edit ${iconClasses ?? ''}`}
            stroke="currentColor"
            strokeWidth="1.08333"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M5.95898 2.1665H2.16732C1.88 2.1665 1.60445 2.28064 1.40129 2.4838C1.19812 2.68697 1.08398 2.96252 1.08398 3.24984V10.8332C1.08398 11.1205 1.19812 11.396 1.40129 11.5992C1.60445 11.8024 1.88 11.9165 2.16732 11.9165H9.75065C10.038 11.9165 10.3135 11.8024 10.5167 11.5992C10.7198 11.396 10.834 11.1205 10.834 10.8332V7.0415" />
            <path d="M4.33398 8.66663L4.87565 6.49996L10.0215 1.35413C10.237 1.13864 10.5292 1.01758 10.834 1.01758C11.1387 1.01758 11.431 1.13864 11.6465 1.35413C11.862 1.56962 11.983 1.86188 11.983 2.16663C11.983 2.47137 11.862 2.76364 11.6465 2.97913L6.50065 8.12496L4.33398 8.66663" />
        </svg>
    );
};

export default IconEdit;
